import { useContext, useEffect, useState } from "react";
import {useRouteLoaderData} from "react-router-dom";

import { getLabConfig } from '../../utils/api';
import LabIDContext from '../../store/LabIDContext';
	
	const PendingOrderItem = (props) => {
		const { reqNumber, name, orderDT, releasedRaw, disReqNum, pending, reqTests, destlab, status, PPURL, webURL} = props.item;
		const released = Number(releasedRaw);
		const tests = name.split("~");
		const token = useRouteLoaderData('root');
		const labid = useContext(LabIDContext);

		const ReqURL = webURL + labid + '/lpi3/?event=dtc.DTC&reqnumlist=';
		let ScheduleHUBURL=PPURL;
		if(!PPURL.includes("localhost")) {
			ScheduleHUBURL = PPURL + '/' + labid + '/scheduleHub' 
		}
		const labtestid = sessionStorage.getItem("Labtestid");
	    const historyURL = PPURL +"RPP/" + labid + "/patientportal/" + labid + "/history?token=" + token + "&labtestid=" + labtestid;

		const [scheduleHub,setScheduleHub] = useState('0');
		useEffect(() => {
			(async () => {
			  const sched = await getLabConfig("SCHEDULEHUB");
			  setScheduleHub(sched);
			})();
		  }, []);	  
		return (

		<tr>
		  <td>{orderDT}</td>
		  
		  <td colSpan="2">
			{destlab === 'LCA' && status !== 'CYNERGY Rejected' && (
					<a
					  href="https://www.labcorp.com/labs-and-appointments/results"
					  target="_blank"
					  rel="noopener noreferrer"
					>
					  Click here to schedule with LabCorp
					</a>
			  )}
			{tests.map((indTest, index) => (
			  <div key={index} style={{ marginBottom: '1em' }}>
				<p>{indTest.split(' -')[1]}</p>
				{reqTests[index]?.['AdditionalInfo']?.['i3Screen.scheduling_url'] ? (
				  <a
					href={reqTests[index]['AdditionalInfo']['i3Screen.scheduling_url']}
					target="_blank"
					rel="noopener noreferrer"
				  >
					Click here to schedule or view Donor Pass
				  </a>
				) :  null}
				{scheduleHub==="On" && 
					<a
					  href={`${ScheduleHUBURL}?reqnumber=${reqNumber}&displayReqNum=${disReqNum}&token=${token}`}
					  target="_scheduleHub"
					  title="Scheduler"
					  rel="noopener noreferrer"
					>
						Schedule your Lab Visit
					</a>
					}
			  </div>
			))}
		  </td>

		  <td>
		  {status !== 'CYNERGY Rejected' &&
			<a
			  href={`${ReqURL}${reqNumber}&token=${token}`}
			  target="_prtReq"
			  title="Print Requisition"
			  rel="noopener noreferrer"
			>
			  {disReqNum}
			</a>
		  }
		  {status === 'CYNERGY Rejected' &&
		  	<>{disReqNum}</>
		  }
		  </td>
	<td>
			{status === 'CYNERGY Rejected' || status === 'i3Screen Rejected'
				? "Denied"
				: released === 1 && pending === 1
				? "Approved"
				: pending !== 1
				? <a href= {historyURL} title="Results" target="_RPP">Resulted</a>
				: released !== 1
				? "Pending"
				: ""}
		  </td>

			
		</tr>

		  
	  );
	};

export default PendingOrderItem;